import { render } from "./dayone.vue?vue&type=template&id=f8c259fc"
import script from "./dayone.vue?vue&type=script&lang=js"
export * from "./dayone.vue?vue&type=script&lang=js"

import "./dayone.vue?vue&type=style&index=0&id=f8c259fc&lang=scss"
script.render = render

export default script